// src/sagas/portfolioSagas.js
import { put, call, takeEvery, all } from 'redux-saga/effects';
import { currentPosition, bookedplposition, getMarketData, closeAllOrders, clientPositionsGet } from '../../services/allApiService';
import { filterOrdersByExchange } from '../../components/utils/portfolioUtils';
import {
    fetchCurrentPositionsSuccess,
    fetchSquaredOffPositionsSuccess,
    fetchPortfolioFailure,
    fetchMarketData,
    fetchMarketDataSuccess,
    fetchMarketDataFailure,
    closeAllOrdersSuccess,
    closeAllOrdersFailure,
    fetchCurrentPositions,
    clientPositionsGetSuccess
} from '../../actions/portfolioActions';



export function* fetchCurrentPositionsSaga({ payload: { activeTabList } }) {
    try {
        const response = yield call(currentPosition);
        let data = response.data;
        if (Array.isArray(data)) {
            data = mergePositions(data);

            data = filterOrdersByExchange(data, activeTabList);

            const tokens = data.reduce((acc, item) => {
                const mappedExchange = item.exchange === 'EQUITY' || item.exchange === 'EQUITY(INDEX)' ? 'NFO' : item.exchange;
                if (!acc[mappedExchange]) acc[mappedExchange] = [];
                acc[mappedExchange].push(item.token);
                return acc;
            }, {});

            yield put(fetchCurrentPositionsSuccess({ orders: data, exchangeTokens: tokens }));
            yield put(fetchMarketData(tokens));
        } else {
            yield put(fetchCurrentPositionsSuccess({ orders: [], allmarketData: [], exchangeTokens: {} }));
        }
    } catch (error) {
        yield put(fetchPortfolioFailure(error.message));
    }
}

export function* fetchSquaredOffPositionsSaga({ payload: { activeTabList } }) {
    try {
        const response = yield call(bookedplposition);
        let data = response.data;

        if (Array.isArray(data)) {
            data = filterOrdersByExchange(data, activeTabList);
            yield put(fetchSquaredOffPositionsSuccess({ orders: data }));
        } else {
            yield put(fetchSquaredOffPositionsSuccess({ orders: [] }));
        }
    } catch (error) {
        yield put(fetchPortfolioFailure(error.message));
    }
}

export function* fetchMarketDataSaga({ payload: exchangeTokens }) {
    try {
        if (!exchangeTokens || Object.keys(exchangeTokens).length === 0) return;

        // ── ONE-TIME snapshot for last prices (works even when the market is
        // closed). The Portfolio component's repeating poll is already disabled
        // while the socket is connected, so this fires once on load; the socket
        // then keeps P&L live.
        const mode = 'FULL';
        const marketData = yield call(getMarketData, mode, exchangeTokens);
        const fetchedData = marketData.data?.fetched || [];

        yield put(fetchMarketDataSuccess(fetchedData));

    } catch (error) {
        yield put(fetchMarketDataFailure(error.message));
    }
}

export function* closeAllOrdersSaga({ payload: { activeTab, activeTabList } }) {
    try {
        yield call(closeAllOrders);
        yield put(closeAllOrdersSuccess());

        yield put(fetchCurrentPositions(activeTabList));
    } catch (error) {
        yield put(closeAllOrdersFailure(error.message));
    }
}

export function* initializePortfolioSaga({ payload: { activeTabList } }) {
    try {
        yield put(fetchCurrentPositions(activeTabList));

        yield put({ type: 'FETCH_SQUARED_OFF_POSITIONS', payload: { activeTabList } });
    } catch (error) {
        yield put(fetchPortfolioFailure(error.message));
    }
}

export function* clientPositionsGetSaga() {
    try {
        const response = yield call(clientPositionsGet);

        yield put(clientPositionsGetSuccess(response.data));
    } catch (error) {
        yield put(fetchPortfolioFailure(error.message));
    }
}

export default function* portfolioRootSaga() {
    yield all([
        takeEvery('INITIALIZE_PORTFOLIO', initializePortfolioSaga),
        takeEvery('FETCH_CURRENT_POSITIONS', fetchCurrentPositionsSaga),
        takeEvery('FETCH_SQUARED_OFF_POSITIONS', fetchSquaredOffPositionsSaga),
        takeEvery('FETCH_MARKET_DATA', fetchMarketDataSaga),
        takeEvery('CLOSE_ALL_ORDERS', closeAllOrdersSaga),
        takeEvery('CLIENT_POSITIONS_GET', clientPositionsGetSaga),
    ]);
}

// function mergePositions(data) {
//     const merged = {};

//     data.forEach(item => {
//         const key = `${item.token}-${item.type}`;
//         if (!merged[key]) {
//             merged[key] = { ...item };
//             merged[key].qty = Number(item.qty);
//             merged[key].lots = Number(item.lots);
//             merged[key].invested = Number(item.invested);
//             merged[key].price = Number(item.price);
//             merged[key].avarage_price = Number(item.price);
//             merged[key].brokerage = Number(item.brokerage)
//         } else {

//             merged[key].qty += Number(item.qty);
//             merged[key].lots += Number(item.lots);
//             merged[key].invested += Number(item.invested);
//             merged[key].brokerage += Number(item.brokerage)
//             merged[key].price += Number(item.price)
//             merged[key].trade_count += 1;

//             merged[key].avarage_price =
//                 merged[key].price / merged[key].trade_count;

//             console.log(merged[key].trade_count);
//             if (new Date(item.created_at) > new Date(merged[key].created_at)) {
//                 merged[key].created_at = item.created_at;
//                 merged[key].price = Number(item.price);
//             }
//         }
//     });

//     return Object.values(merged);
// }

function mergePositions(data) {
    const merged = {};

    data.forEach(item => {
        const key = `${item.token}-${item.type}`;

        if (!merged[key]) {
            merged[key] = {
                ...item,
                qty: Number(item.qty),
                lots: Number(item.lots),
                invested: Number(item.invested),
                price: Number(item.price),
                brokerage: Number(item.brokerage),

                price_sum: Number(item.price),
                trade_count: 1,
                avarage_price: Number(item.price)
            };
        } else {
            merged[key].qty += Number(item.qty);
            merged[key].lots += Number(item.lots);
            merged[key].invested += Number(item.invested);
            merged[key].brokerage += Number(item.brokerage);

            merged[key].price_sum += Number(item.price);
            merged[key].trade_count += 1;

            merged[key].avarage_price =
                merged[key].price_sum / merged[key].trade_count;

            if (new Date(item.created_at) > new Date(merged[key].created_at)) {
                merged[key].created_at = item.created_at;
                merged[key].price = Number(item.price);
            }
        }
    });


    return Object.values(merged).map(({ price_sum, trade_count, ...rest }) => rest);
}
